/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Features_Ex_RdlInputs */

const en_features_ex_rdl = /** @type {(inputs: Features_Ex_RdlInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Romanian deadlift`)
};

const pl_features_ex_rdl = /** @type {(inputs: Features_Ex_RdlInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Martwy ciąg rumuński`)
};

/**
* | output |
* | --- |
* | "Romanian deadlift" |
*
* @param {Features_Ex_RdlInputs} inputs
* @param {{ locale?: "en" | "pl" }} options
* @returns {LocalizedString}
*/
export const features_ex_rdl = /** @type {((inputs?: Features_Ex_RdlInputs, options?: { locale?: "en" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Features_Ex_RdlInputs, { locale?: "en" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pl") return pl_features_ex_rdl(inputs)
	return en_features_ex_rdl(inputs)
});